import BaseDTO from '../base/BaseDTO';

export default class SampleHardwareRevision extends BaseDTO {

    public pcbVersion: string;
    public description: string;
    public hasMatchingPhysicalSamples: boolean;

    constructor(data: { [key: string]: any }) {
        super(data);
        this.pcbVersion = data['pcbVersion'];
        this.description = data['description'];
        this.hasMatchingPhysicalSamples = data['hasMatchingPhysicalSamples'] ?? false;
    }
}